import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { breadcrumbAction } from "../../redux/actions/config.action";
import { getMerchantKeyForAdmin, regenerateMerchantKeyForAdmin } from "../../redux/actions/admin/integration.action";
import InputField from "../../components/formControl/input/InputField";
import SvgIcon from "../../components/Images/SvgIcon";
import { showToast } from "../../lib/global";

const IntegrationAdmin = () => {
    const dispatch = useDispatch();
    const [storeId, setStoreId] = useState("");
    const [appKey, setAppKey] = useState("");
    const [showKey, setShowKey] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const breadcrumb = [
            { label: "Setting", url: null },
            { label: "Integration", url: null }
        ];
        dispatch(breadcrumbAction(breadcrumb));
        
        const sid = localStorage.getItem("storeId");
        if (sid) {
            setStoreId(sid);
            fetchKeyData(sid);
        }
    }, [dispatch]);

    const fetchKeyData = (sid) => {
        setLoading(true);
        dispatch(getMerchantKeyForAdmin(sid)).then((response) => {
            if (response?.data?.status === 200) {
                setAppKey(response?.data?.data?.appKey || "");
            } else {
                setAppKey("");
            }
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleRegenerate = () => {
        if (!storeId) {
            showToast("Store ID is missing", "error");
            return;
        }
        if (window.confirm("Are you sure you want to regenerate the App Key for this merchant? The old key will no longer work.")) {
            setLoading(true);
            dispatch(regenerateMerchantKeyForAdmin(storeId)).then((response) => {
                if (response?.data?.status === 200) {
                    setAppKey(response?.data?.data?.appKey || "");
                    showToast("App Key regenerated successfully", "success");
                } else {
                    showToast(response?.data?.message || "Failed to regenerate App Key", "error");
                }
            }).finally(() => {
                setLoading(false);
            });
        }
    };

    const handleCopy = (text) => {
        if (!text) return;
        navigator.clipboard.writeText(text);
        showToast("Copied to clipboard", "success");
    };

    return (
        <div className="container-fluid">
            <div className="card p-4">
                <h5 className="mb-4">Information</h5>
                
                <div className="form-group mb-4">
                    <label className="text-muted mb-2">Store ID</label>
                    <div className="d-flex align-items-center">
                        <InputField
                            type="text"
                            value={storeId}
                            readOnly
                            formClass="flex-grow-1"
                            inputClass="bg-light"
                        />
                        <button 
                            className="btn btn-outline-secondary ml-2"
                            onClick={() => handleCopy(storeId)}
                            title="Copy Store ID"
                            disabled={!storeId}
                        >
                            <SvgIcon src="/icons/duplicate.svg" style={{ width: '18px' }} />
                        </button>
                    </div>
                </div>

                <div className="form-group mb-4">
                    <label className="text-muted mb-2">App Key</label>
                    <div className="d-flex align-items-center">
                        <InputField
                            type={showKey ? "text" : "password"}
                            value={appKey}
                            readOnly
                            formClass="flex-grow-1"
                            inputClass="bg-light"
                            placeholder={loading ? "Loading..." : "No App Key"}
                        />
                        <div className="d-flex ml-2">
                            <button 
                                className="btn btn-outline-secondary mr-2"
                                onClick={() => setShowKey(!showKey)}
                                title={showKey ? "Hide" : "Show"}
                                disabled={!appKey}
                            >
                                <SvgIcon src="/icons/view_icon.svg" style={{ width: '18px' }} />
                            </button>
                            <button 
                                className="btn btn-outline-secondary mr-2"
                                onClick={() => handleCopy(appKey)}
                                title="Copy"
                                disabled={!appKey}
                            >
                                <SvgIcon src="/icons/duplicate.svg" style={{ width: '18px' }} />
                            </button>
                            <button 
                                className="btn btn-outline-danger"
                                onClick={handleRegenerate}
                                title="Regenerate"
                                disabled={loading || !storeId}
                            >
                                <img src="/icons/Refresh_live.png" alt="refresh" style={{ width: '18px' }} />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IntegrationAdmin;
